export default function Footer() {
  return (
    <footer
      className="w-full py-6 px-4 text-center"
      style={{
        background: "#8b0000",
        borderTop: "2px solid rgba(212,160,23,0.4)",
      }}
    >
      <div className="max-w-md mx-auto space-y-1.5">
        <p className="text-sm font-bold" style={{ color: "#ffd700", fontFamily: "'Noto Serif SC', serif" }}>
          匠心打造精品在线测算
        </p>
        <p className="text-xs" style={{ color: "rgba(255,220,180,0.6)" }}>
          需付费后方可查看结果，结果纯属娱乐仅供参考
        </p>
        <div className="pt-1 space-y-1">
          <p className="text-xs" style={{ color: "rgba(255,220,180,0.5)" }}>
            © 2026 运势测算 · 传承中华文化
          </p>
        </div>
      </div>
    </footer>
  );
}
